"use strict";
/*
 * Copyright (C) 2019-2021 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * SDF based text rendering for TypeScript.
 *
 * @remarks
 *
 * @packageDocumentation
 */
__exportStar(require("./lib/rendering/FontCatalog"), exports);
__exportStar(require("./lib/rendering/GlyphData"), exports);
__exportStar(require("./lib/rendering/TextStyle"), exports);
__exportStar(require("./lib/rendering/TextBufferObject"), exports);
__exportStar(require("./lib/TextCanvas"), exports);
__exportStar(require("./lib/utils/ContextualArabicConverter"), exports);
__exportStar(require("./lib/utils/MaterialUtils"), exports);
__exportStar(require("./lib/utils/TypesettingUtils"), exports);
__exportStar(require("./lib/utils/UnicodeUtils"), exports);
//# sourceMappingURL=index.js.map